export function sanitizeDigits(value: string, maxLength?: number): string {
  const digitsOnly = value.replace(/\D/g, '');
  return typeof maxLength === 'number' ? digitsOnly.slice(0, maxLength) : digitsOnly;
}

export function formatAbn(value: string): string {
  const digits = sanitizeDigits(value, 11);

  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
  if (digits.length <= 8) return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;

  return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
}

export function sanitizeAbn(value: string): string {
  return formatAbn(value);
}

export function sanitizeAcn(value: string): string {
  return sanitizeDigits(value, 9);
}

export function sanitizePhone(value: string, maxLength = 20): string {
  const sanitized = value.replace(/[^\d+\-() ]/g, '');
  return sanitized.slice(0, maxLength);
}
